import { roles } from '@nxsys/store/constants';
import CompanyListing from '../../../modules/companies/listing';
import CompanyDetail from '../../../modules/companies/detail';
import EmailTemplateEdit from '../../../modules/companies/detail/EmailTemplateEdit';

export const companiesConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/companies',
    element: <CompanyListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/companies/:companyId',
    element: <CompanyDetail />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/companies/:companyId/email-templates/:emailTemplateId/edit',
    element: <EmailTemplateEdit />,
  },
];
